import { render, staticRenderFns } from "./CardItemDepartment.vue?vue&type=template&id=0454ba61&scoped=true"
import script from "./CardItemDepartment.vue?vue&type=script&lang=js"
export * from "./CardItemDepartment.vue?vue&type=script&lang=js"
import style0 from "./CardItemDepartment.vue?vue&type=style&index=0&id=0454ba61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454ba61",
  null
  
)

export default component.exports